// Vendor imports
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Client V2 common imports
const { navigate } = require('client-v2/common/state/router/actions')
// Container imports
const AppNav = require('./component-dumb')

function mapStateToProps(state) {
  if (!state.user.loggedIn) {
    // Hide the nav bar for logged-out users
    return { hidden: true, items: [] }
  }
  // Determine selected state
  return {
    hidden: state.env.nativeEmbedded,
    items: itemsSelector(state),
    selected: navSelectedState(state)
  }
}

const mapDispatchToProps = {
  onNavigate: navigate
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  AppNav
)

// Helpers

const NAV_ITEMS = [
  {
    id: 'for-you',
    title: 'For you',
    href: '/for-you',
    aliases: [
      '/',
      '/add',
      '/mixit',
      '/top-for-you'
    ]
  },
  {
    id: 'following',
    title: 'Following',
    href: '/following',
    aliases: [
      '/recently-added'
    ]
  },
  {
    id: 'popular',
    title: 'Popular',
    href: '/popular',
    aliases: [
      '/mix',
      '/interests',
      '/collections',
      '/people',
      '/explore',
      '/explore/interests',
      '/explore/collections',
      '/explore/people'
    ]
  },
  {
    id: 'shared',
    title: 'Shared',
    href: '/shared',
    aliases: []
  }
]


function navSelectedState(state) {
  const { pathname } = state.router.location
  for (let item of NAV_ITEMS) {
    if (item.href === pathname || item.aliases.includes(pathname)) {
      return item.id
    }
  }
}

// Helpers

const itemsSelector = createSelector(
  state => state.user.hasRollout('web_internal_share'),
  webInternalShare => NAV_ITEMS.filter(item => {
    if (item.id === 'shared') {
      return webInternalShare
    }
    return true
  })
)
